import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AgentTypesService } from './data-access/services/agent-types.service';
import { AgentType } from './data-access/models/agent-type.model';
import { ModalConfirmComponent } from '../../shared/ui/components/modal-confirm/modal-confirm.component';
import { OauthService } from '../login/data-access/services/oauth.service';

@Component({
  selector: 'app-agent-types',
  standalone: true,
  imports: [CommonModule, ModalConfirmComponent],
  templateUrl: './agent-types.component.html',
  styles: []
})
export class AgentTypesComponent implements OnInit {
  private router = inject(Router);
  private agentTypesService = inject(AgentTypesService);
  private oauthService = inject(OauthService);

  agentTypes: AgentType[] = [];
  showConfirmModal = false;
  selectedAgentType: AgentType | null = null;
  currentUser: any = null;

  ngOnInit() {
    this.loadAgentTypes();
    this.loadCurrentUser();
  }

  loadCurrentUser() {
    this.oauthService.getCurrentUser().subscribe({
      next: (user) => {
        this.currentUser = user;
      },
      error: (error) => {
        console.error('Error cargando usuario actual:', error);
      }
    });
  }

  loadAgentTypes() {
    this.agentTypesService.getAgentTypes().subscribe({
      next: (agentTypes) => {
        this.agentTypes = agentTypes;
      },
      error: (error) => {
        console.error('Error cargando tipos de agente:', error);
      }
    });
  }

  managePrompt(agentType: AgentType) {
    this.router.navigate(['/agents'], { 
      queryParams: { type: agentType.name } 
    });
  }

  onToggleChange(agentType: AgentType) {
    if (!this.isCurrentUserAdmin()) {
      return;
    }
    
    this.selectedAgentType = agentType;
    this.showConfirmModal = true;
  }

  onModalAction(action: string) {
    if (action === 'confirm' && this.selectedAgentType) {
      const newValue = !this.selectedAgentType.transcription_active;
      
      this.agentTypesService.updateAgentType(this.selectedAgentType.id, newValue).subscribe({
        next: () => {
          this.selectedAgentType!.transcription_active = newValue;
          this.closeModal();
        },
        error: (error) => {
          console.error('Error actualizando transcription_active:', error);
          this.closeModal();
        }
      });
    } else {
      this.closeModal();
    }
  }

  private closeModal() {
    this.showConfirmModal = false;
    this.selectedAgentType = null;
  }

  isCurrentUserAdmin(): boolean {
    if (!this.currentUser || !this.currentUser.roles) {
      return false;
    }
    return this.currentUser.roles.some((role: any) => role.id === 1);
  }
}
